var { get } = require('lodash');

var Deeplinker = {
    deeplink: function(prov, betOffer, outcome, stake) {
        switch (prov) {
            case 'ds':
                return this.deeplinkDS(betOffer, outcome, stake);
            case 'leovegas':
                return this.deeplinkLeoVegas(betOffer, outcome, stake);
            case 'unibet':
                return this.deeplinkUnibet(betOffer, outcome, stake);
            case '138':
                return this.deeplink138(betOffer, outcome, stake);
            case 'bethard':
                return this.deeplinkBethard(betOffer, outcome, stake, 'en');
            case 'comeon':
                return this.deeplinkComeOn(betOffer, outcome, stake, 'en');
            case 'comeon__de':
                return this.deeplinkComeOn(betOffer, outcome, stake, 'de');
            default:
                return '';
        }
    },
    deeplinkBS: function(prov, bets, stake) {
        switch (prov) {
            case 'ds':
                return this.deeplinkDSBS(bets, stake);
            case 'leovegas':
                return this.deeplinkLeoVegasBS(bets, stake);
            case 'unibet':
                return this.deeplinkLeoVegasBS(bets, stake);
            default:
                return '';
        }
    },

    deeplink138: (betOffer, outcome, stake) => {
        const sportId = get(betOffer, 'meta.bookmakerSportId');
        const leagueId = get(betOffer, 'meta.bookmakerLeagueId');
        const eventId = get(betOffer, 'meta.bookmakerEventId');
        const outcomeId = get(outcome, 'id');
        if (outcomeId) {
            return `https://138.fsbtech.com/sportsbook/${sportId}/${leagueId}/${eventId}/#s_${outcomeId}`;
        } else if (eventId) {
            return `https://138.fsbtech.com/sportsbook/${sportId}/${leagueId}/${eventId}`;
        }
    },

    deeplinkComeOn: (betOffer, outcome, stake, lang = 'en') => {
        if (outcome && outcome.id) {
            return `http://m.comeon.com/${lang}/mobilegoto.aspx?LineID=${outcome.id}&StakeAmount=${stake}`;
        } else if (betOffer && betOffer.bookmakerEventId) {
            return `http://m.comeon.com/${lang}/mobilegoto.aspx?EventID=${betOffer.bookmakerEventId}`;
        }
    },

    deeplinkBethard: (betOffer, outcome, stake, lang = 'en') => {
        if (outcome && outcome.id) {
            return `https://www.bethard.com/sports?LineID=${outcome.id}&StakeAmount=${stake}`;
        } else if (betOffer && betOffer.bookmakerEventId) {
            return `https://www.bethard.com/sports?EventID=${betOffer.bookmakerEventId}`;
        }
    },

    deeplinkDS: function(betOffer, outcome, stake) {
        var base = 'https://oddsetmobil.danskespil.dk/webapp/sportsbook/';
        return base + '#betslip/sel1=' + outcome.id + '&stk1=' + stake;
    },

    deeplinkLeoVegas: function(betOffer, outcome, stake) {
        var base = 'https://www.leovegas.com/sv';
        return base + '#sportsbook/home?coupon=single|' + outcome.id + '|' + stake + '|append|wdp-campaign';
    },
    deeplinkUnibet: function(betOffer, outcome, stake) {
        var base = 'https://www.unibet.com/betting';
        return base + '#sportsbook/home?coupon=single|' + outcome.id + '|' + stake + '|append|wdp-campaign';
    },
    deeplinkDSBS: function(bets, stake) {
        var base = 'https://oddsetmobil.danskespil.dk/webapp/sportsbook/';
        var params = '';
        if (Array.isArray(bets)) {
            bets.forEach(bets, function(e, i) {
                params += 'sel' + (i + 1) + '=' + e.outcome.id + '&stk' + (i + 1) + '=' + stake + '&';
            });
        }
        return base + '#betslip/' + params + '&stkacc=' + stake;
    },
    deeplinkLeoVegasBS: function(bets, stake) {
        var base = 'https://www.leovegas.com/sv';
        return (
            base +
            '#sportsbook/home?coupon=combination|' +
            bets
                .map(e => {
                    return e.outcome.id;
                })
                .join(',') +
            '|' +
            stake +
            '|replace|eurocampaign'
        );
    },
};

module.exports = Deeplinker;



/** WEBPACK FOOTER **
 ** ../src/widgets/helpers/BookieDeeplinker.js
 **/